import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		borderRadius: THEME.common.borderRadius,
	},
	dropZone: {
		alignItems: 'center',
		border: `2px dashed ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		justifyContent: 'center',
		padding: THEME.spacing.md,
		transition: 'border-color 0.15s, background 0.15s',
	},
	dropZoneDragging: {
		background: THEME.colors.primary.light,
		borderColor: THEME.colors.primary.main,
	},
	dropZoneCenter: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	dropZoneLabel: {
		alignItems: 'center',
		color: THEME.colors.text.main,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		gap: THEME.spacing.xs,
	},
	dropZoneBrowse: {
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		fontWeight: THEME.typography.fontWeights.semibold,
		textDecoration: 'underline',
	},
	dropZoneSubtitle: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		textAlign: 'center',
	},
	headerRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: THEME.spacing.sm,
	},
	headerLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		letterSpacing: '0.05em',
		textTransform: 'uppercase',
	},
	headerActions: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	toggleRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	toggleLabel: {
		color: THEME.colors.text.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
		userSelect: 'none',
	},
	chipList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
	chip: {
		alignItems: 'center',
		background: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box' as const,
		color: THEME.colors.text.main,
		display: 'inline-flex',
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.xs,
		maxWidth: '80%',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
	},
	chipSuccess: {
		background: THEME.colors.success.light,
		borderColor: THEME.colors.success.main,
	},
	chipSecureLink: {
		background: THEME.colors.primary.light,
		borderColor: THEME.colors.primary.main,
	},
	chipError: {
		background: THEME.colors.danger.light,
		borderColor: THEME.colors.danger.main,
	},
	chipPending: {
		opacity: 0.7,
	},
	chipName: {
		color: THEME.colors.text.main,
		...THEME.common.truncate,
	},
	chipSize: {
		color: THEME.colors.text.light,
		flexShrink: 0,
	},
	chipRemove: {
		height: 'auto',
		width: 'auto',
	},
	error: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.xs,
	},
	infoText: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontStyle: 'italic',
		marginTop: THEME.spacing.xs,
	},
});
